import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="site-footer">
      <p>© {new Date().getFullYear()} Gates of Music. Tous droits réservés.</p>
    </footer>
  );
}
